export enum LocalStorageKey {
  LatestCategoryNavMenu = 'LatestCategoryNavMenu',
  BestCategoryNavMenu = 'BestCategoryNavMenu',
  RankingCategoryNavMenu = 'RankingCategoryNavMenu',
  EpisodeOrderType = 'EpisodeOrderType',
  NoticeOrderType = 'NoticeOrderType',
  EpisodeReplyOrder = 'EpisodeReplyOrder',
  MyFavoriteContentsRefineType = 'MyFavoriteContentsRefineType',
  MyRecentContentsRefineType = 'MyRecentContentsRefineType',
  ViewerTheme = 'ViewerTheme',
  ViewerFont = 'ViewerFont',
  ViewerFontSize = 'ViewerFontSize',
  ViewerLineHeight = 'ViewerLineHeight',
  ViewerParagraphIndent = 'ViewerParagraphIndent',
  ViewerPadding = 'ViewerPadding',
  ViewerIndentation = 'ViewerIndentation',
  ViewerViewType = 'ViewerViewType',
  ViewerFancyShare = 'ViewerFancyShare',
  ViewerViewTypeNoti = 'ViewerViewTypeNoti',
  InAppReviewRequestAt = 'InAppReviewRequestAt',
  ViewerFancyShareOptionGuide = 'ViewerFancyShareOptionGuide',
  ActivityPointInduceBottomModalHideTime = 'ActivityPointInduceBottomModalHideTime',
  AuthorSurveyBottomModalHideTime = 'AuthorSurveyBottomModalHideTime',
  AppInstallBottomModalHideTime = 'AppInstallBottomModalHideTime',
  FavoriteCategoryBottomModalHideTime = 'FavoriteCategoryBottomModalHideTime',
  AppInstallForPushBottomModalHideTime = 'AppInstallForPushBottomModalHideTime',
  AppPushOnBottomModalHideTime = 'AppPushOnBottomModalHideTime',
  NpsCampaignAnsweredId = 'NpsCampaignAnsweredId',
  SeedGenerateTimestamp = 'SeedGenerateTimestamp',
  ModeGuideFABDismissed = 'modeGuideFABDismissed',
  MessageGuideTooltip = 'MessageGuideTooltip',

  // 픽앤츄 4 - 2026
  PickAndChoo4MyStudioContentsTabClicked = 'PickAndChoo4MyStudioContentsTabClicked',
}
